import React from 'react';
import PropTypes from 'prop-types';

/**
 * ButtonGroup component with Tailwind CSS — replaces react-bootstrap ButtonGroup.
 * Joins adjacent buttons into one segmented control (inner corners squared).
 *
 * Usage:
 *   <ButtonGroup aria-label="View mode">
 *     <Button variant="ghost">Day</Button>
 *     <Button variant="ghost">Week</Button>
 *     <Button variant="ghost">Month</Button>
 *   </ButtonGroup>
 */
const JOIN_CLASSES =
  '[&>*:not(:first-child)]:tw-rounded-l-none [&>*:not(:last-child)]:tw-rounded-r-none [&>*:not(:first-child)]:tw--ml-px';

const ButtonGroup = ({ children, className = '', ...props }) => (
  <div role="group" className={`tw-inline-flex tw-items-stretch ${JOIN_CLASSES} ${className}`} {...props}>
    {children}
  </div>
);

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ButtonGroup;
